// Module
var code = `<table class="table table--generate-row-ids">
  <thead>
  <tr>
    <th>No.</th>
    <th>Property</th>
    <th>Value</th>
  </tr>
  </thead>
  <tbody>
  <tr>
    <td></td>
    <td class="label">Name</td>
    <td>
      <input type="text"
             ng-if="\$ctrl.isCustomizableFee()"
             ng-model="\$ctrl.feeDefinition.feeName"
             ng-maxlength="32"
             ng-required="true"/>
      <span ng-if="!\$ctrl.isCustomizableFee()">
          {{\$ctrl.feeDefinition.feeName}}
        </span>
    </td>
  </tr>
  <tr ng-if="\$ctrl.productGroup === 'DEPOSIT'">
    <td></td>
    <td>Fee class</td>
    <td>
      <select class="fee-class"
              ng-model="\$ctrl.feeDefinition.feeClass"
              ng-change="\$ctrl.feeClassChange()"
              ng-disabled="\$ctrl.isWithholdingTaxFee()"
              ng-options="feeClass | prettyEnum for feeClass in \$ctrl.feeClasses"
              ng-required="true">
      </select>
    </td>
  </tr>
  <tr>
    <td></td>
    <td>Type</td>
    <td>
      <select class="fee-type"
              ng-model="\$ctrl.feeDefinition.feeType"
              ng-change="\$ctrl.feeTypeChange()"
              ng-disabled="\$ctrl.isAccountEarlyClosureFee()"
              ng-options="feeType | prettyEnum for feeType in \$ctrl.getFeeTypes()"
              ng-required="true">
      </select>
      <div ng-if="\$ctrl.canFeeUseBoard()">
        <label class="fee-as-board">
          <input
            type="checkbox"
            ng-change="\$ctrl.useFeeBoardChange()"
            ng-model="\$ctrl.useFeeBoard"/>
          Use board
        </label>
      </div>
      <help ng-if="\$ctrl.isAccountCustomFee()"
            title="Value may change based on 'Apply On' value.">
      </help>
    </td>
  </tr>
  <tr ng-if="['FIXED', 'PERCENTAGE'].includes(\$ctrl.feeDefinition.feeType)">
    <td></td>
    <td>Value</td>
    <td>
      <cash ng-if="\$ctrl.feeDefinition.feeType == 'FIXED'"
            ng-model="\$ctrl.feeDefinition.fixedAmount"
            ng-disabled="\$ctrl.useFeeBoard"
            ng-required="!\$ctrl.useFeeBoard"
      ></cash>
      <glue-container append-percentage="true" ng-if="\$ctrl.feeDefinition.feeType == 'PERCENTAGE'">
        <input type="number"
               ng-model="\$ctrl.feeDefinition.percentageAmount"
               ng-disabled="\$ctrl.useFeeBoard"
               ng-required="!\$ctrl.useFeeBoard" min="0" max="100" step="0.00001"/>
      </glue-container>
      <div class="alert" ng-if="['PENALTY', 'PENALTY_MATURITY'].includes(\$ctrl.feeDefinition.feeClass)
        && \$ctrl.feeDefinition.feeType == 'PERCENTAGE'
        && \$ctrl.productConfig.loanInterestType === 'ADD_ON_RATE'
        && \$ctrl.productConfig.amortizationType === 'DIMINISHING_EQUAL_AMORTIZATION'">
        Rate is based on monthly add-on
      </div>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.feeType === 'FORMULA'">
    <td></td>
    <td>Formula</td>
    <td>
      <textarea
        rows="3"
        ng-model="\$ctrl.feeDefinition.formula"
        maxlength="2000"
        class="override-resizable"
        required>
      </textarea>
      <help ng-click="\$ctrl.toggleFormulaHelp()" title="Click to toggle help"></help>
      <div ng-if="\$ctrl.showFormulaHelp">
        <p></p>
        <p>Variables:</p>
        <p><code>loan.principalAmount</code> - original principal</p>
        <p><code>loan.principalBalance</code> - outstanding principal</p>
        <p><code>loan.interestAmount</code> - original interest</p>
        <p><code>loan.interestBalance</code> - outstanding interest</p>
        <p><code>loan.releaseAmount</code> - original release amount</p>
        <p><code>loan.maturityDate</code> - maturity date</p>
        <p><code>loan.interestRate</code> - interest rate</p>
        <p><code>loan.term</code> - term in days</p>
        <p><code>loan.branchSystemDate</code> - product branch system date (in epoch days)</p>
        <p><code>loan.grantDate</code> - grant date (in epoch days)</p>
        <p><code>loan.releaseDate</code> - release date (in epoch days)</p>
        <p><code>loan.previousLoans</code> - list of previous (restructured/remade/renewed) loans</p>
        <p><code>loan.fees</code> - name & amount pairs of calculated and already applied fees</p>
        <p><code>loan.customerAge</code> - age of the customer</p>
        <p><code>loan.amortization</code> - details of the amortization<help ng-click="\$ctrl.showAmortizationDetails()" title="More details"></help></p>
        <p><code>loan.uidLedgerEntries</code> - list of uid ledger entries<help ng-click="\$ctrl.showUidLedgerEntryDetails()" title="More details"></help></p>
        <p><code>loan.customField</code> - list of loan custom fields<help ng-click="\$ctrl.showCustomFees()" title="More details"></help></p>
        <p></p>
        <p>Functions:</p>
        <p><code>requireCustomFields(...names)</code> - indicates that the provided custom fields are required</p>
        <p><code>epochDaysToDate(epochDays)</code> - converts epoch days to date</p>
        <div class="alert alert-info">Fees may or may not be accessible depending on the calculation order</div>
      </div>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.feeType === 'PERCENTAGE' && ['LOAN'].includes(\$ctrl.productGroup)">
    <td></td>
    <td>Calculation method</td>
    <td>
      <select ng-model="\$ctrl.feeDefinition.calculationMethod"
              ng-change="\$ctrl.updateExtraOptions()"
              ng-options="o.value as o.label for o in \$ctrl.loanCalculationMethods"
              ng-required="true">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.feeType === 'PERCENTAGE' && ['CUSTOM', 'DOC_STAMP'].includes(\$ctrl.feeDefinition.feeClass) && \$ctrl.productGroup === 'DEPOSIT'">
    <td></td>
    <td>Calculation method</td>
    <td>
      <select ng-model="\$ctrl.feeDefinition.calculationMethod"
              ng-change="\$ctrl.updateExtraOptions()"
              ng-options="value | prettyEnum for value in \$ctrl.depositCalculationMethods"
              ng-required="true">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.feeType === 'PERCENTAGE' && \$ctrl.feeDefinition.feeClass === 'CUSTOM' && \$ctrl.productGroup === 'ACCOUNT'">
    <td></td>
    <td>Calculation method</td>
    <td>
      <select ng-model="\$ctrl.feeDefinition.calculationMethod"
              ng-change="\$ctrl.updateExtraOptions()"
              ng-options="value | prettyEnum for value in \$ctrl.accountCalculationMethods"
              ng-required="true">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.calculationMethod === 'PERCENTAGE_OF_DEDUCTION_COLLECTED_ON_RELEASE'">
    <td></td>
    <td>Include in calculation:</td>
    <td>
      <multiselect items="\$ctrl.deductionParts"
                   ng-model="\$ctrl.selectedDeductionParts"
                   label-property="'name'"
                   value-property="'name'"
                   ng-change="\$ctrl.updateSelectedDeductionFees()"
                   ng-required="true">
      </multiselect>
    </td>
  </tr>
  <tr ng-if="['PERCENTAGE_OF_ORIGINAL_PRINCIPAL_WITH_CUSTOM_DIVISOR', 'PERCENTAGE_BASED_ON_YEAR_OUTSTANDING_BALANCE',
            'ROUNDED_PERCENTAGE_OF_ORIGINAL_PRINCIPAL_WITH_CUSTOM_DIVISOR', 'ROUNDED_PERCENTAGE_OF_TOTAL_BALANCE_WITH_CUSTOM_DIVISOR']
            .includes(\$ctrl.feeDefinition.calculationMethod)">
    <td></td>
    <td>Divisor</td>
    <td>
      <input type="number"
             ng-model="\$ctrl.feeDefinition.extraOptions.DIVISOR"
             ng-required="['PERCENTAGE_OF_ORIGINAL_PRINCIPAL_WITH_CUSTOM_DIVISOR', 'ROUNDED_PERCENTAGE_OF_ORIGINAL_PRINCIPAL_WITH_CUSTOM_DIVISOR',
             'ROUNDED_PERCENTAGE_OF_TOTAL_BALANCE_WITH_CUSTOM_DIVISOR'].includes(\$ctrl.feeDefinition.calculationMethod)" min="0" step="1"/>
    </td>
  </tr>
  <tr ng-if="['ROUNDED_PERCENTAGE_OF_ORIGINAL_PRINCIPAL_WITH_CUSTOM_DIVISOR','ROUNDED_PERCENTAGE_OF_TOTAL_BALANCE_WITH_CUSTOM_DIVISOR'].includes(\$ctrl.feeDefinition.calculationMethod)">
    <td></td>
    <td>Rounding scale</td>
    <td>
      <select ng-model="\$ctrl.feeDefinition.extraOptions.ROUNDING_SCALE"
              ng-options="value | prettyEnum for value in \$ctrl.roundingScales"
              ng-required="true">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.feeClass === 'CUSTOM' && !\$ctrl.isAccountCustomFee()">
    <td></td>
    <td>Branch Id</td>
    <td>
      <multiselect items="\$ctrl.branches"
                   ng-model="\$ctrl.branchesIds"
                   ng-change="\$ctrl.branchesIdsChange()"
                   label-property="'name'"
                   value-property="'id'"
                   ng-required="true"></multiselect>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.feeClass === 'CUSTOM'">
    <td></td>
    <td>Branch posting</td>
    <td>
      <select class="fee-type"
              ng-model="\$ctrl.feeDefinition.postingStrategy"
              ng-options="o.value as o.label for o in \$ctrl.postingStrategyOptions"
              ng-change="\$ctrl.postingStrategyChanged(\$ctrl.feeDefinition.postingStrategy)"
              ng-required="true">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.postingStrategy === 'TARGET_BRANCH'">
    <td></td>
    <td>Target posting branch</td>
    <td>
      <select class="fee-type"
              ng-model="\$ctrl.feeDefinition.postingBranchId"
              ng-options="o.id as o.name for o in \$ctrl.branches"
              ng-required="\$ctrl.feeDefinition.postingStrategy === 'TARGET_BRANCH'">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.isCustomizableFee() && !\$ctrl.shouldDisableCreatedOn() && !\$ctrl.isAccountCustomFee()">
    <td></td>
    <td>Calculate on</td>
    <td class="calculate-on-field">
      <select ng-model="\$ctrl.feeDefinition.calculateOn"
              ng-disabled="\$ctrl.shouldDisableCalculateOn()"
              ng-change="\$ctrl.updateFeeDefinition()"
              ng-options="value | prettyEnum for value in \$ctrl.getCalculateOnProductHooks()"
              ng-required="true">
      </select>
      <help
        title="Available options for 'Apply On' and 'Calculation Method' (if applicable) will change depending on the selected 'Calculate On' value">
      </help>
    </td>
  </tr>
  <tr ng-if="\$ctrl.shouldDisableCreatedOn()">
    <td></td>
    <td>Calculate on</td>
    <td class="calculate-on-field">
      <select ng-model="\$ctrl.feeDefinition.calculateOn"
              disabled
              required>
        <option value="CREATE">Create</option>
      </select>
    </td>
  </tr>

  <tr ng-if="\$ctrl.feeDefinition.feeClass === 'PENALTY'">
    <td></td>
    <td>Apply on maturity</td>
    <td>
      <select
        required
        ng-model="\$ctrl.feeDefinition.applyOnMaturity"
        ng-options="option.value as option.label for option in \$ctrl.penaltyApplyOnMaturityOptions">
      </select>
    </td>
  </tr>

  <tr ng-if="\$ctrl.feeDefinition.feeClass === 'PENALTY_MATURITY'">
    <td></td>
    <td>Apply on</td>
    <td>
      <select ng-model="\$ctrl.feeDefinition.amortizationHook"
              ng-options="hook | prettyEnum for hook in \$ctrl.amortizationHooks"
              ng-required="true">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.isCustomizableFee()">
    <td></td>
    <td>Apply on</td>
    <td>
      <select ng-model="\$ctrl.feeDefinition.applyOn"
              ng-change="\$ctrl.onApplyOnChange()"
              ng-disabled="\$ctrl.shouldDisableApplyOn()"
              ng-options="value | prettyEnum for value in \$ctrl.getApplyOnProductHooks()"
              ng-required="true">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.loanArbitraryFeesApplyOnApplicable">
    <td></td>
    <td>Apply on</td>
    <td>
      <select ng-model="\$ctrl.feeDefinition.applyOn"
              ng-options="value | prettyEnum for value in \$ctrl.loanArbitraryFeesApplyOnHooks"
              ng-change="\$ctrl.updateIncludedInEirComputation()"
              ng-required="true">
      </select>
      <help title="Available options for 'Collect by' will change depending on the selected 'Apply On' value"></help>
    </td>
  </tr>

  <tr ng-if="\$ctrl.feeDefinition.feeClass === 'CUSTOM' || \$ctrl.feeDefinition.feeClass === 'DOC_STAMP'">
    <td></td>
    <td>Order</td>
    <td>
      <input type="number"
             ng-model="\$ctrl.feeDefinition.calculationOrder"
             ng-required="true"
             min="1"
             step="1"/>
    </td>
  </tr>

  <tr ng-if="\$ctrl.feeDefinition.feeClass === 'CUSTOM' && !\$ctrl.isAccountCustomFee() && \$ctrl.feeDefinition.calculateOn === 'PLEDGE_DEPOSIT_DEVIATION'">
    <td></td>
    <td>Apply fee to statuses</td>
    <td>
      <multiselect items="\$ctrl.statusesOptions"
                   ng-model="\$ctrl.feeDefinition.applyOnStatuses"
                   ng-change="\$ctrl.selectedStatusChange()"
                   ng-required="true">
      </multiselect>
    </td>
  </tr>

  <tr ng-if="\$ctrl.isLoanApplyYearlyEnabled()">
    <td></td>
    <td>Apply yearly</td>
    <td>
      <select ng-model="\$ctrl.loanApplyYearly"
              boolean-options
              ng-change="\$ctrl.updateExtraOptions()"
              ng-required="true">
      </select>
    </td>
  </tr>

  <tr ng-if="\$ctrl.collectionTypeEnabled()">
    <td></td>
    <td>Collection type</td>
    <td>
      <select
        required
        ng-model="\$ctrl.feeDefinition.collectionType"
        ng-options="collectionType | prettyEnum for collectionType in \$ctrl.getChargeCollectionTypes()"
        ng-change="\$ctrl.collectionTypeChanged(\$ctrl.feeDefinition.collectionType)"
      >
      </select>
    </td>
  </tr>

  <tr ng-if="\$ctrl.collectionTypeEnabled() && \$ctrl.feeDefinition.collectionType === 'FULL'">
    <td></td>
    <td>Apply collection on</td>
    <td>
      <select
        required
        ng-model="\$ctrl.feeDefinition.extraOptions.FEE_COLLECTION_SCHEDULE"
        ng-change="\$ctrl.collectionScheduleChanged(\$ctrl.feeDefinition.extraOptions.FEE_COLLECTION_SCHEDULE)"
        ng-options="collectionSchedule | prettyEnum for collectionSchedule in \$ctrl.feeCollectionScheduleOptions">
      </select>
    </td>
  </tr>

  <tr ng-if="\$ctrl.collectionTypeEnabled()
              && \$ctrl.feeDefinition.collectionType === 'FULL'
              && \$ctrl.feeDefinition.feeClass === 'PENALTY_MATURITY'
              && \$ctrl.feeDefinition.extraOptions.FEE_COLLECTION_SCHEDULE === 'MONTH_END'">
    <td></td>
    <td>Allow perpetual calculation</td>
    <td>
      <input
        type="checkbox"
        ng-model="\$ctrl.feeDefinition.extraOptions.ALLOW_PERPETUAL_CALCULATION"/>
    </td>
  </tr>

  <tr ng-if="\$ctrl.isDepositDocStamp()">
    <td></td>
    <td>Bank expense</td>
    <td>
      <input
        type="checkbox"
        ng-model="\$ctrl.feeDefinition.bankExpense"/>
    </td>
  </tr>

  <!--    amortized fees related config  start  -->

  <tr ng-if="\$ctrl.feeDefinition.applyOn === 'LOAN_AMORTIZATION'">
    <td></td>
    <td>Amortized fee type</td>
    <td>
      <select
        ng-model="\$ctrl.feeDefinition.feeAmortizationType"
        ng-options="value | prettyEnum for value in \$ctrl.feeAmortizationTypes"
        ng-required="true"
        ng-change="\$ctrl.amortizationTypeChanged()">
      </select>
    </td>
  </tr>

  <tr ng-if="\$ctrl.feeDefinition.feeAmortizationType === 'PERCENTAGE'">
    <td></td>
    <td>Spread percentage:</td>
    <td>
      <glue-container append-percentage="true">
        <input type="number"
               ng-model="\$ctrl.feeDefinition.amortizedFeeConfig.AMORTIZED_FEE_CONFIG.spreadPercentage"
               required
               min="0" max="100">
      </glue-container>
    </td>
  </tr>

  <tr ng-if="['CYCLIC', 'EQUALLY_CYCLIC'].includes(\$ctrl.feeDefinition.feeAmortizationType)">
    <td></td>
    <td>Spread fee every:</td>
    <td>
      <glue-container append="'amortizations'">
        <input type="number"
               ng-model="\$ctrl.feeDefinition.amortizedFeeConfig.AMORTIZED_FEE_CONFIG.spreadEvery"
               required
               min="1" max="365">
      </glue-container>
    </td>
  </tr>

  <tr ng-if="['EQUALLY_CYCLIC', 'EQUALLY'].includes(\$ctrl.feeDefinition.feeAmortizationType)">
    <td></td>
    <td>Starting amortization number:</td>
    <td>
      <glue-container>
        <input type="number"
               ng-model="\$ctrl.feeDefinition.amortizedFeeConfig.AMORTIZED_FEE_CONFIG.startingAmortizationNumber"
               required
               min="1">
      </glue-container>
    </td>
  </tr>

  <tr ng-if="\$ctrl.feeDefinition.feeAmortizationType === 'EQUALLY_CYCLIC'">
    <td></td>
    <td>Apply fee for:</td>
    <td>
      <glue-container>
        <input type="number"
               ng-model="\$ctrl.feeDefinition.amortizedFeeConfig.AMORTIZED_FEE_CONFIG.applyFeeFor"
               required
               min="1" ng-max="\$ctrl.feeDefinition.amortizedFeeConfig.AMORTIZED_FEE_CONFIG.spreadEvery">
      </glue-container>
    </td>
  </tr>

  <!-- amortized fees related config end -->


  <tr
    ng-if="(\$ctrl.feeDefinition.feeClass === 'CUSTOM' || \$ctrl.feeDefinition.applyOn === 'LOAN_AMORTIZATION') && !\$ctrl.isAccountCustomFee()">
    <td></td>
    <td>Rounding scale</td>
    <td>
      <select ng-model="\$ctrl.feeDefinition.roundingScale"
              ng-options="value | prettyEnum for value in \$ctrl.roundingScales"
              ng-required="true">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.feeClass === 'CUSTOM' && \$ctrl.productGroup === 'LOAN'">
    <td></td>
    <td>Creation type</td>
    <td>
      <multiselect items="\$ctrl.loanCreationTypes"
                   ng-model="\$ctrl.selectedLoanCreationTypes"
                   ng-change="\$ctrl.loanCreationTypesChange()"
                   label-property="'label'"
                   value-property="'value'"
                   ng-required="true">
      </multiselect>
    </td>
  </tr>
  <tr ng-if="\$ctrl.showIncludedInEir()">
    <td></td>
    <td>Included in EIR computation</td>
    <td>
      <select
        ng-model="\$ctrl.feeDefinition.includedInEirComputation"
        ng-disabled="\$ctrl.feeDefinition.forAccretion"
        boolean-options
        ng-change="\$ctrl.clearAccretionSettings()"
        required>
      </select>
      <help
        title="BIR regulations state that Doc Stamp,Service Charge,Application Fee and Notarial Fees must be included in EIR computation"></help>
    </td>
  </tr>
  <tr
    ng-if="\$ctrl.productGroup === 'LOAN' && \$ctrl.feeDefinition.feeClass === 'CUSTOM' && \$ctrl.feeDefinition.applyOn === 'LOAN_RELEASE' && \$ctrl.feeDefinition.includedInEirComputation">
    <td></td>
    <td>For Accretion</td>
    <td>
      <select
        ng-model="\$ctrl.feeDefinition.forAccretion"
        ng-change="\$ctrl.changeForAccretion()"
        ng-disabled="\$ctrl.feeDefinition.id"
        boolean-options
        required>
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.productGroup === 'LOAN' && \$ctrl.feeDefinition.feeClass === 'CUSTOM' && \$ctrl.feeDefinition.applyOn === 'LOAN_RELEASE' && \$ctrl.feeDefinition.forAccretion">
    <td></td>
    <td>Include already paid fees on discount charges</td>
    <td>
      <select
        ng-model="\$ctrl.feeDefinition.alwaysIncludeOnDiscountCharges"
        boolean-options
        required>
      </select>
      <help title="Always include the fee amount on discount charges creation even if already paid upfront"></help>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.feeClass === 'INSURANCE_FEE'">
    <td></td>
    <td>Collect by</td>
    <td>
      <select
        ng-model="\$ctrl.feeDefinition.insuranceFeeOptions.insuranceFeeDeductionStrategy"
        ng-options="value | prettyEnum for value in \$ctrl.getInsuranceFeeDeductionStrategies()"
        ng-required="true">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.feeDefinition.feeClass === 'INSURANCE_FEE' &&
               \$ctrl.feeDefinition.insuranceFeeOptions.insuranceFeeDeductionStrategy === 'TRANSFER_TO_ACCOUNT'">
    <td></td>
    <td>Insurance service fee</td>
    <td>
      <account-select options="\$ctrl.loanInsuranceAccounts"
                      field-mapping="{accountGroup: 'customer', accountGroupMaxLength: Number.MAX_SAFE_INTEGER, name: 'productNumber'}"
                      value-field="'id'"
                      ng-model="\$ctrl.feeDefinition.insuranceFeeOptions.insuranceSavingsAccount"
                      required>
      </account-select>
    </td>
  </tr>
  <!-- Deposit specific properties -->
  <tr ng-if="\$ctrl.productGroup === 'DEPOSIT' && \$ctrl.feeDefinition.feeClass === 'CUSTOM' && \$ctrl.feeDefinition.calculateOn === 'DEPOSIT_PRETERMINATION'">
    <td></td>
    <td>Day calculation type</td>
    <td>
      <select
        ng-change="\$ctrl.depositAgeChange()"
        ng-model="\$ctrl.depositAgeType"
        ng-required="true">
        <option value="fixedValue">Fixed value</option>
        <option value="percentage">Percentage</option>
      </select>
    </td>
  </tr>
  <tr
    ng-if="\$ctrl.productGroup === 'DEPOSIT' && \$ctrl.feeDefinition.feeClass === 'CUSTOM' && \$ctrl.depositAgeType === 'fixedValue' && \$ctrl.feeDefinition.calculateOn === 'DEPOSIT_PRETERMINATION'">
    <td></td>
    <td>Apply when terminated given or less days after opened</td>
    <td>
      <glue-container append="'days'">
        <input type="number"
               min="1"
               ng-model="\$ctrl.depositAgeFixedValue"
               ng-required="true"
               ng-change="\$ctrl.depositAgeChange()"/>
      </glue-container>
    </td>
  </tr>
  <tr
    ng-if="\$ctrl.productGroup === 'DEPOSIT' && \$ctrl.feeDefinition.feeClass === 'CUSTOM' && \$ctrl.depositAgeType === 'percentage' && \$ctrl.feeDefinition.calculateOn === 'DEPOSIT_PRETERMINATION'">
    <td></td>
    <td>Apply when terminated given or less percentage of term days after opened</td>
    <td>
      <glue-container append="'% days'">
        <input type="number"
               min="0" max="100"
               ng-model="\$ctrl.depositAgePercentage"
               ng-required="true"
               ng-change="\$ctrl.depositAgeChange()"/>
      </glue-container>
    </td>
  </tr>
  <tr ng-if="\$ctrl.shouldShowDeductFromPrincipal()">
    <td></td>
    <td>Deduct from amortization principal</td>
    <td>
      <select
        ng-model="\$ctrl.feeDefinition.extraOptions.DEDUCT_FROM_AMORTIZATION_PRINCIPAL"
        boolean-options
        required>
      </select>
      <help title="When true, fee amount is deducted from the principal and added to the last amortization"></help>
    </td>
  </tr>
  <tr ng-if="\$ctrl.shouldShowPenaltyCalculationType()">
    <td></td>
    <td>Apply penalty based on</td>
    <td>
      <select ng-model="\$ctrl.feeDefinition.extraOptions.PENALTY_DAYS_CALCULATION_TYPE"
              ng-class="{'nx-invalid': !\$ctrl.isPenaltyCalculationTypeValid()}"
              ng-options="o.value as o.label for o in \$ctrl.penaltyDaysCalculationTypes"
              ng-required="true">
      </select>
      <help ng-if="!\$ctrl.isPenaltyCalculationTypeValid()" title="Penalty by loan status cannot be used in conjunction with 'use board'"></help>
    </td>
    <validator condition="\$ctrl.isPenaltyCalculationTypeValid()"></validator>
  </tr>
  <tr ng-if="\$ctrl.shouldShowCalculateOnStatus()">
    <td></td>
    <td>Apply on status</td>
    <td>
      <multiselect items="\$ctrl.penaltyStatuses"
                   select-all-option="true"
                   label-property="'label'"
                   value-property="'value'"
                   ng-model="\$ctrl.feeDefinition.calculateOnStatuses"
                   ng-required="true">
      </multiselect>
    </td>
  </tr>
  <tr ng-if="\$ctrl.shouldShowVisibilitySetting()">
    <td></td>
    <td>Display fee on loan creation</td>
    <td>
      <select
        ng-model="\$ctrl.feeDefinition.displayOnProductCreation"
        boolean-options
        required>
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.productGroup === 'ACCOUNT' && \$ctrl.shouldShowCollectBy(\$ctrl.feeDefinition.feeClass)">
    <td></td>
    <td>Collect by</td>
    <td>
      <select class="fee-class"
              ng-model="\$ctrl.feeDefinition.extraOptions.AGENT_CHARGE_COLLECTION_TYPE"
              ng-options="c | prettyEnum for c in \$ctrl.agentChargeCollectionTypes"
              ng-required="true">
      </select>
    </td>
  </tr>

  <tr ng-if="\$ctrl.isAccountEarlyClosureFee()">
    <td></td>
    <td>Early closure less or equal days:</td>
    <td>
      <input type="number"
             min="1"
             ng-model="\$ctrl.feeDefinition.predicates[0].value"
             required/>
    </td>
  </tr>

  <tr ng-if="\$ctrl.isPartnerOperation()">
    <td></td>
    <td>Provider:</td>
    <td>
      <select
        class="fee-class"
        ng-model="\$ctrl.feeDefinition.extraOptions.ACCOUNT_PARTNER_OPERATION_PROVIDER"
        ng-options="c | prettyEnum for c in \$ctrl.accountPartnerOperationProviders"
        ng-required="true">
      </select>
    </td>
  </tr>

  <tr ng-if="\$ctrl.isAccountTaggedMemoFee()">
    <td></td>
    <td>External tag equal to:</td>
    <td>
      <input type="text"
             maxlength="32"
             required
             ng-model="\$ctrl.feeDefinition.predicates[0].value"/>
    </td>
  </tr>

  <tr ng-if="\$ctrl.isExternalTransfer()">
    <td></td>
    <td>External transfer channel:</td>
    <td>
      <select
        class="fee-class"
        ng-change="\$ctrl.onExternalTransferChannelChange()"
        ng-model="\$ctrl.feeDefinition.predicates[0].value"
        ng-options="c | prettyEnum for c in \$ctrl.externalTransferChannels"
        ng-required="true">
      </select>
    </td>
  </tr>

  <tr ng-if="\$ctrl.isExternalTransfer() && \$ctrl.getPredicateOfType('ExternalTransferFeePredicate').value === 'INSTAPAY'">
    <td></td>
    <td>Transfer type:</td>
    <td>
      <select
        class="fee-class"
        ng-model="\$ctrl.transferTypePredicate"
        ng-change="\$ctrl.onExternalTransferChannelChange()"
        ng-options="o.value as o.label for o in \$ctrl.externalTransferTypes"
        ng-required="true">
      </select>
    </td>
  </tr>

  <tr ng-if="\$ctrl.isExternalTransfer()">
    <td></td>
    <td>On insufficient funds:</td>
    <td>
      <fee-overdraft-strategy
        ng-model="\$ctrl.externalTransferOverDraftStrategy"
        ng-change="\$ctrl.setOverDraftStrategy()"
        ng-required="\$ctrl.isExternalTransfer()">
      </fee-overdraft-strategy>
    </td>
  </tr>

  <tr ng-if="\$ctrl.isFeeSharingApplicable()">
    <td></td>
    <td>Allow fee sharing</td>
    <td>
      <select
        ng-model="\$ctrl.feeDefinition.allowFeeSharing"
        boolean-options
        ng-required="true">
      </select>
      <help title="When enabled, a part of this fee can be credited to a partner account configured with 'Edit fee sharing' on the deposit account"></help>
    </td>
  </tr>

  </tbody>
</table>

<div ng-if="\$ctrl.useFeeBoard && \$ctrl.productGroup === 'LOAN'">
  <custom-fee-board fee-type="\$ctrl.feeDefinition.feeType"
                    fee-class="\$ctrl.feeDefinition.feeClass"
                    apply-on="\$ctrl.feeDefinition.applyOn"
                    board="\$ctrl.feeDefinition.extraOptions.LOAN_BOARD"
                    board-type="'LOAN_BOARD'"></custom-fee-board>
</div>
<div
  ng-if="\$ctrl.useFeeBoard && \$ctrl.productGroup === 'DEPOSIT' && \$ctrl.feeDefinition.feeClass === 'WITHHOLDING_TAX'">
  <custom-fee-board fee-type="\$ctrl.feeDefinition.feeType"
                    fee-class="\$ctrl.feeDefinition.feeClass"
                    board="\$ctrl.feeDefinition.extraOptions.WITHHOLDING_TAX_BOARD"
                    board-type="'WITHHOLDING_TAX_BOARD'"></custom-fee-board>
</div>
<div ng-if="\$ctrl.useFeeBoard && \$ctrl.isDepositDocStamp()">
  <custom-fee-board fee-type="\$ctrl.feeDefinition.feeType"
                    fee-class="\$ctrl.feeDefinition.feeClass"
                    board="\$ctrl.feeDefinition.extraOptions.DEPOSIT_DOC_STAMP_BOARD"
                    board-type="'DEPOSIT_DOC_STAMP_BOARD'"></custom-fee-board>
</div>
<div ng-if="\$ctrl.useFeeBoard && \$ctrl.feeDefinition.extraOptions.ACCOUNT_FEE_BOARD">
  <custom-fee-board fee-type="\$ctrl.feeDefinition.feeType"
                    fee-class="\$ctrl.feeDefinition.feeClass"
                    board="\$ctrl.feeDefinition.extraOptions.ACCOUNT_FEE_BOARD"
                    board-type="'ACCOUNT_FEE_BOARD'"></custom-fee-board>
</div>
<div ng-if="\$ctrl.useFeeBoard && \$ctrl.feeDefinition.extraOptions.AGENT_FEE_BOARD">
  <custom-fee-board fee-type="\$ctrl.feeDefinition.feeType"
                    fee-class="\$ctrl.feeDefinition.feeClass"
                    board="\$ctrl.feeDefinition.extraOptions.AGENT_FEE_BOARD"
                    board-type="'AGENT_FEE_BOARD'"></custom-fee-board>
</div>
<div ng-if="\$ctrl.isPledgeDepositDeviationIntervalFeeBoardShown()">
  <pledge-deposit-deviation-interval-fee-board
    board="\$ctrl.feeDefinition.extraOptions.PLEDGE_DEPOSIT_DEVIATION_INTERVAL_FEE_BOARD"
    fee-type="\$ctrl.feeDefinition.feeType"
  ></pledge-deposit-deviation-interval-fee-board>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/charge/custom-fee.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;